export default __webpack_public_path__ + "static/media/sowmz-crop.745ac001.jpg";